import { useTranslation } from 'react-i18next'

import { useEchoConnection } from '@/hooks/useEchoConnection'
import { cn } from '@/lib/utils'

/**
 * Zeigt, ob das Handy noch am Realtime-Server hängt.
 *
 * Im Unterricht ist das die Antwort auf „bei mir passiert nichts": entweder
 * der Punkt ist grün und es liegt an der Lehrkraft, oder er ist rot und das
 * WLAN ist weg.
 */
export function ConnectionBadge({ className }: { className?: string }) {
    const { t } = useTranslation()
    const connection = useEchoConnection()

    const label = {
        connected: t('session.connected'),
        connecting: t('session.connecting'),
        unavailable: t('session.offline'),
    }[connection]

    return (
        <div
            className={cn('flex items-center gap-2 text-[11px] font-bold text-wb-dim', className)}
            data-testid="connection"
            data-state={connection}
            aria-live="polite"
        >
            <span
                className={cn(
                    'size-2 rounded-full',
                    connection === 'connected' && 'bg-wb-win',
                    connection === 'connecting' && 'animate-pulse bg-wb-warn',
                    connection === 'unavailable' && 'bg-wb-loss',
                )}
            />
            {label}
        </div>
    )
}
